import React from 'react';

import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import CheckCircle from '@/assets/svgs/check-circle.svg';
import { Button } from '@/components/ui/button';

interface UpToDateStateProps {
  timeAgoText: string;
  onRefresh: () => void;
}

export const UpToDateState = ({ timeAgoText, onRefresh }: UpToDateStateProps) => {
  const { t } = useTranslation(['authenticated.settings']);

  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium">
            {t('authenticated.settings:pages.integrations.refreshCard.upToDate.title')}
          </h3>
          <img alt={t('onboarding.passedStep')} src={CheckCircle} className="size-4 text-success" />
        </div>
        <p className="text-xs text-muted-foreground">
          {t('authenticated.settings:pages.integrations.refreshCard.upToDate.subtitle')}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <span className="text-xs text-muted-foreground">{timeAgoText}</span>
        <Button size="sm" variant="default" onClick={onRefresh}>
          <RefreshCw className="h-4 w-4" />
          {t('authenticated.settings:pages.integrations.refreshCard.upToDate.action')}
        </Button>
      </div>
    </div>
  );
};
